import React, { Component } from 'react';
import {findDOMNode} from 'react-dom'
import { Input, Label, Icon } from 'components';

import ReactTooltip from 'react-tooltip'
import styles from './InputRow.scss';

import newId from '../../../_util/newId';


class InputRow extends Component {

  constructor(props) {
    super(props);
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
      if(prevProps.tip !== this.props.tip) {
        ReactTooltip.rebuild();
      }
  }
  componentWillMount() {
    this.id = newId();
  }
  showTooltip() {
    setTimeout(() => {
      ReactTooltip.show(findDOMNode(this.refs[this.id]))
    },100);
  }  
  hideTooltip() {
    setTimeout(() => {
      ReactTooltip.hide(findDOMNode(this.refs[this.id]))
    },100);
  } 
  render() {
    let classNames = styles.inputRow
    if(this.props.theme == 'light'){
      classNames = classNames + ' ' + styles.isLight
    }

    if(this.props.cols){
      let colClass = 'col-' + this.props.cols
      classNames = classNames + ' ' + styles[colClass]
    }

    let stateString = '';
    if(this.props.state){

      classNames = classNames + ' ' + styles.hasState
      
      if(this.props.state === 'loading') {
        stateString = <div className={styles.state}><div className={styles.stateLoadingRing}><div></div><div></div><div></div><div></div></div></div>
      }
      else {
        stateString = <div className={styles.state}><Icon type="image" content={this.props.state} /></div>
      }
    }

    let iconString = '';
    if(this.props.icon){
      let specialStyles = {}

      if(this.props.state || this.props.unit){
        specialStyles = {right: '38px'}

        if(this.props.state && this.props.unit){
          specialStyles = {right: '63px'}
        }
      }

      iconString =  <div className={styles.icon} style={specialStyles}>
                      <Icon type="image" content={this.props.icon} />
                    </div>
    }

    let unitString = '';
    if(this.props.unit){
      let unitStyles = styles.unit
      classNames = classNames + ' ' + styles.hasUnit

      if(this.props.state){
        unitStyles = unitStyles + ' ' + styles.unitState
      }

      unitString = <div className={unitStyles}>{this.props.unit}</div>
    }

    let hintString = '';
    if(this.props.hint){
      if(!this.props.state){
        let hintStyles = styles.hint
        classNames = classNames + ' ' + styles.hasHint

        if(this.props.state){
          hintStyles = hintStyles + ' ' + styles.hintState
        }

        hintString =  <div data-tip={this.props.hint} data-event='click' data-for='GlobalTooltip' className={hintStyles}>
                          <Icon type="image" content="hint" size="13px" />
                      </div>

      }
    }

    if(this.props.isRight){
      classNames = classNames + ' ' + styles.isRight
    }

    if(this.props.noMargin){
      classNames = classNames + ' ' + styles.noMargin
    }


    return (
        <div className={classNames} data-tip={this.props.tip} data-event='click focus' ref={this.id} data-for='GlobalTooltip'>
            {this.props.children}
            <Label label={this.props.label} styles={this.props.labelStyle} />
            {stateString}
            {unitString}
            {iconString}
            {hintString}
        </div>
    )
  }
}

export default InputRow



// WEBPACK FOOTER //
// ./src/components/molecules/InputRow/index.js